import React, { memo, useCallback } from 'react';
import { Container, RemoveButton, ProviderIcon, H3, RemoveIconWrapper } from "./SsoCredentials.styles";
import { CancelIcon } from '@chegg-ui/theme';
import { removeSsoCredentials } from "../../../store/reducer";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import getProviderIcon from "../../Social/getProviderIcon";
var SsoCredentials = function SsoCredentials() {
  var email = useAppSelector(function (state) {
    return state.sso.email;
  });
  var authProvider = useAppSelector(function (state) {
    return state.sso.authProvider;
  });
  var dispatch = useAppDispatch();
  var removeSsoEmail = useCallback(function () {
    dispatch(removeSsoCredentials());
  }, [dispatch]);
  var icon = getProviderIcon(authProvider);
  return /*#__PURE__*/React.createElement(Container, {
    "data-test": 'sso_credentials_view'
  }, /*#__PURE__*/React.createElement(ProviderIcon, null, icon), /*#__PURE__*/React.createElement(H3, null, email), /*#__PURE__*/React.createElement(RemoveButton, {
    "data-test": "sso_email_remove",
    onClick: removeSsoEmail,
    type: "button"
  }, /*#__PURE__*/React.createElement(RemoveIconWrapper, null, /*#__PURE__*/React.createElement(CancelIcon, {
    size: 'xsmall',
    svgColor: 'black',
    iconFill: 'circlefill'
  }))));
};
export default /*#__PURE__*/memo(SsoCredentials);